export default __webpack_public_path__ + "static/media/add.1af2c079.svg";